import * as React from "react";
import * as ReactDOM from "react-dom";
import 'whatwg-fetch';

const ButtonMenuId = "workflowNotificationsBtn";

function lazyWithPreload(factory) {
	const Component: any = React.lazy(factory);
	Component.preload = factory;
	return Component;
}

const NotificationsPanel = lazyWithPreload(() => import(/* webpackChunkName: "notificationsPanel" */ './NotificationsPanel'));

class Notifications extends React.Component<{}, any> {
	constructor(params) {
		super(params);
		this._element = React.createRef();
		this.state = {
			open: false,
			loaded: false,
		}
	}

	_element: any;

	componentDidMount() {

		let btn = document.getElementById(ButtonMenuId);
		if (btn) {
			btn.addEventListener("click", (e) => {
				if (this.state.open) {
					this.close();
				} else {
					this.open();
				}
			});

			btn.addEventListener("mouseenter", () => {
				this.setState({ loaded: true });
				NotificationsPanel.preload();
			});
		}

		document.addEventListener("click", (e) => {
			if (this.state.open) {
				if (!this._element.current || !this._element.current.contains(e.target)) {
					if (!btn || !btn.contains(e.target as Node)) {
						this.close();
					}
				}
			}
		});
	}

	open() {
		if (!this.state.open) {
			this.setState({ open: true, loaded: true });

			let btn = document.getElementById(ButtonMenuId);
			btn.classList.add("active");
		}
	}

	close() {
		if (this.state.open) {
			this.setState({ open: false });

			let btn = document.getElementById(ButtonMenuId);
			btn.classList.remove("active");
		}
	}

	handleOnClose() {
		this.close();
	}

	render() {

		if (this.state.loaded) {

			let style = { display: "none" };
			if (this.state.open) {
				style = null;
			}

			return <div style={style} ref={this._element} >
				<React.Suspense fallback={null}>
					<NotificationsPanel onClose={this.handleOnClose.bind(this)} />
				</React.Suspense>
			</div>;
		}
		return null;
	}
}

export default function Init() {
	let content = document.getElementById("workflowNotifications");
	var quickAddIssue: any = ReactDOM.render(<Notifications />, content);
}